
import './afw/js/polyfills.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './afw/store/configureStore';
import App from './App';
import Pace from 'pace-js-amd-fix';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });
Pace.start({ trackMethods: ['GET', 'POST', 'DELETE', 'PUT', 'PATCH'] });
// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');
history.listen((location, action) => {
    window.scrollTo(0, 0);
});
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
        <App />
    </ConnectedRouter>
  </Provider>,
rootElement);
